module.exports = __webpack_public_path__ + "static/img/news22_2.7ab4f77.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news22_2.jpeg
// module id = S9Ly
// module chunks = 0